import { SohoModel } from '~/constants/SohoModel'

/**
 * Format the relationships so they can be updated
 *
 * @export
 * @param {*} params
 * @param {[ key: string ]: SohoModel} relationshipTypes
 * @returns
 */
export function formatRelationships (
  params: any,
  relationshipTypes: { [relationshipKey: string]: SohoModel }
) {
  const relationshipKeys = Object.keys(relationshipTypes)

  const finalParams = { ...params }

  finalParams.relationships = {}

  relationshipKeys.forEach(relationshipKey => {
    const relationship = params[relationshipKey]

    if (!relationship) {
      return
    }

    delete finalParams[relationshipKey]

    finalParams.relationships[relationshipKey] = {
      id: relationship.id,
      type: relationshipTypes[relationshipKey]
    }
  })

  return finalParams
}
